// extracted by mini-css-extract-plugin
module.exports = {"root":"EmbeddedTweet_root__D83V1","tweet":"EmbeddedTweet_tweet__XJFqL"};